<template>
  <p v-for="message in messages" class="pFontRed">{{ message }}</p>
  <section
    v-for="helpWrap in helpList"
    :key="helpWrap.category_id"
    class="modBasicSec"
  >
    <h2 class="modBasicSecTitle lyPt16 lyPb16">{{ helpWrap.category_name }}</h2>
    <table class="modBasicTable" style="overflow: visible">
      <thead>
      <tr>
        <th class="lyW70 mdAlignLeft" style="border-radius: 0">タイトル</th>
        <th class="lyW15">ステータス</th>
        <th class="lyW15" style="border-radius: 0">表示順変更</th>
      </tr>
      </thead>
      <draggable
        v-model="helpWrap.helps"
        item-key="order_num"
        tag="tbody"
        handle='.js-drag-btn'
        @change="changeOrder(helpWrap.category_id, helpWrap.helps)"
        @start="dragging=true"
        @end="dragging=false"
      >
        <template #item="{ element }">
          <tr>
            <td>
              <a href="#" class="modColumnLink" @click="openModal_help(element.title, element.content, helpWrap.category_id, element.id)">{{
                  element.title
                }}</a>
            </td>
            <td>
              <div class="pSelectWrap" @click="openStatus">
                <!--.pSelectWrapに.isOpenがつくと、選択肢リスト.pSelectListが開く-->
                <div class="pSelectBox">
                  <div class="pSelectValue" :id="'status_' + element.id">
                    <p class="pSelectMarker mdBlue" :class="statusList[element.status].class">
                      {{ statusList[element.status].name }}</p>
                  </div>
                </div>

                <ul class="pSelectList mdStatus">

                  <li v-for="(status,index) in statusList" @change="changeStatus(element.id, $event)">
                    <label :for="'statusInput_' + element.id + '_'  + index" class="pSelectLabel">
                      <input type="radio" :id="'statusInput_' + element.id + '_'  + index" :name="'status_' + element.id" :value="index" class="pSelectInput">
                      <p class="pSelectMarker" :class="status.class">{{ status.name }}</p>
                    </label>
                  </li>

                </ul>

              </div>
            </td>
            <td>
              <p class="pHandSorting js-drag-btn"><span class="dArm"></span></p>
            </td>
          </tr>
        </template>
      </draggable>
    </table>
    <div class="modBasicSecSwitch">
      <ul class="modBulkSettingList">
        <li>
          <button type="button" class="modBulkSettingBtn mdNc" @click="openModal_help(null,null,helpWrap.category_id)">
            ヘルプを追加
          </button>
        </li>
        <li>
          <button type="button" class="modBulkSettingBtn mdEdit" @click="openModal_cat(helpWrap.category_id, helpWrap.category_name,helpWrap.helps.length)">
            カテゴリー編集
          </button>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import {onMounted, ref} from 'vue';
import draggable from 'vuedraggable'

export default {
  components: {
    draggable: draggable
  },
  setup() {
    //ステータス
    const statusList = ref([]);

    //メッセージ
    const messages = ref([]);
    //ヘルプ一覧
    const helpList = ref([]);

    //状態 dragging
    const dragging = ref(false);
    //状態 connecting
    const connecting = ref(false);

    //結果
    let successBox = ref(null);

    //モーダル背景
    let modalBack = ref(null);

    /**
     * Ajax 通信失敗時に起動させるメソッド
     */
    const _handleError = () => {
      //通信中フラグを false にする
      connecting.value = false;

      //エラーを追加
      messages.value.push('サーバーで処理に失敗しました。再度お試し頂くか、お問い合わせ下さい。');
    };
    /**
     * Ajax 中断時に起動させるメソッド
     */
    const _handleAbort = () => {
      //通信中フラグを false にする
      connecting.value = false;

      //エラーを追加
      messages.value.push('通信が中断されました。再度お試し下さい。');
    };
    /**
     * Ajax タイムアウトに起動させるメソッド
     */
    const _handleTimeout = () => {
      //通信中フラグを false にする
      connecting.value = false;

      //エラーを追加
      messages.value.push('通信タイムアウトしました。ネットワーク回線を確認の上、再度お試し下さい。');
    };

    //サーバー通信 helpList を取得
    const _sync = () => {
      _serverConnect((data) => {
          helpList.value = data
        },
        'get',
        getHelps_ep
      );
    };

    //サーバー通信 無名のヘルプカテゴリー という名前のカテゴリーを追加
    const addCategory = () => {
      _serverConnect((data) => {
          _showSuccess();
          _sync();
        },
        'get',
        addCat_ep + '/無名のヘルプカテゴリー/' + (helpList.value.length + 1)
      );
    };

    //サーバー通信 カテゴリーの名前変更
    const _changeCatName = (catId, catName) => {
      _serverConnect(() => {
          _showSuccess();
          _sync();
        },
        'get',
        changeCatName_ep + '/' + catId + '/' + catName
      );
    };

    //サーバー通信 カテゴリー削除
    const _deleteCat = (catId) => {
      _serverConnect(() => {
          _showSuccess();
          _sync();
        },
        'get',
        delCat_ep + '/' + catId
      );
    }

    //サーバー通信 ヘルプ削除
    const _deleteHelp = (id) => {
      _serverConnect(() => {
          _showSuccess();
          _sync();
        },
        'get',
        delHelp_ep + '/' + id
      );
    }

    //サーバー通信 ヘルプ追加
    const _addHelp = (id, title, contents, catId, status) => {
      const formData = new FormData();
      formData.append("help_category_id", catId);
      formData.append("title", title);
      formData.append("content", contents);
      formData.append("status", status);
      return _serverConnect(() => {
          _showSuccess();
          _sync();
        },
        'post',
        addHelp_ep,
        formData
      ).then(() => {
        return Promise.resolve();
      }).catch((e) => {
        console.log(e);
        return Promise.reject(e);
      });
    }

    //サーバー通信 ヘルプ変更
    const _changeHelp = (id, title, contents, catId, status) => {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("title", title);
      formData.append("content", contents);
      formData.append("status", status);
      return _serverConnect(() => {
          _showSuccess();
          _sync();
        },
        'post',
        changeHelp_ep + '/' + id,
        formData
      ).then(() => {
        return Promise.resolve();
      }).catch((e) => {
        console.log(e);
        return Promise.reject(e);
      });
    }

    //サーバー通信 並び順変更
    const changeOrder = (catId, helps) => {
      const formData = new FormData();
      formData.append("helps", JSON.stringify(helps));
      _serverConnect(() => {
          _showSuccess();
          _sync();
        },
        'post',
        changeHelpOrder_ep,
        formData
      );
    }

    //サーバー通信 ステータス変更
    const _changeStatus = (id, statusId) => {
      _serverConnect(() => {
          _showSuccess();
          _sync();
        },
        'get',
        changeHelpStatus_ep + '/' + id + '/' + statusId
      );
    }

    //サーバーと通信する部分
    const _serverConnect = (onSuccess, openMethod, openUrl, sendBody = null) => {
      //通信中だったら何もしない
      if (connecting.value) {
        return Promise.reject();
      }

      //送信中フラグを on にする
      connecting.value = true;

      //非同期処理開始
      return new Promise((resolve, reject) => {
        //xhr を用意
        const xhr = new XMLHttpRequest();

        //通信失敗時
        xhr.addEventListener('error', () => {
          reject();
          _handleError();
        })
        xhr.addEventListener('timeout', () => {
          reject();
          _handleAbort();
        })
        xhr.addEventListener('abort', () => {
          reject();
          _handleTimeout();
        })

        //通信成功時処理
        xhr.addEventListener('load', event => {
          //送信中フラグを解除
          connecting.value = false;
          //成功・失敗のどちらでも response を JSON としてパースする
          let data = null;
          try {
            data = JSON.parse(event.target.response);
          } catch (e) {
            console.log(e);
            messages.value = ['エラーが発生しました。恐れ入りますが再度お試しください。'];
            reject();
            return;
          }
          //パースに失敗
          if (data === null) {
            messages.value = ['サーバー情報のパースに失敗しました'];
            reject();
            return;
          }
          //失敗判定
          if (event.target.status >= 400) {
            messages.value = data.messages;
            reject(data.messages);
            return;
          }

          //成功したら結果を描写
          onSuccess(data);
          resolve();
        });

        //通信を試みる
        xhr.open(openMethod, openUrl);
        xhr.setRequestHeader('X-CSRF-Token', tokenValue)
        xhr.send(sendBody);
      });
    }

    //更新に成功したtoastを表示
    const _showSuccess = () => {
      if (successBox.value && !successBox.value.classList.contains('isDsply')) {
        successBox.value.classList.add('isDsply');
        successBox.value.style.display = 'block';
        successBox.value.style.zIndex = 9999;
        setTimeout(() => {
          successBox.value.classList.remove('isDsply')
        }, 1500);
      }
    }

    const addEvents = () => {
      //新規ヘルプカテゴリーを追加イベント
      let addCatBtn = document.getElementById('js-add-help-category');
      if (addCatBtn) {
        addCatBtn.addEventListener('click', () => {
          addCategory();
          _sync();
        });
      }
    };

//  ステータス変更セレクトを開く
    const openStatus = (e) => {
      if (!e.currentTarget.classList.contains('isOpen')) {
        e.currentTarget.classList.add('isOpen');
        return;
      }

      e.currentTarget.classList.remove('isOpen');
    };

    const openModal_cat = (catId, catName, helpsLength) => {
      let modalBack = document.getElementById('modModalBack');
      let categoryModal = document.getElementById('ctgryModal');
      let nameInput = document.getElementById('js-helpCatName');
      let idInput = document.getElementById('js-helpCatId');
      let delBtn = document.getElementById('ctgryDelete');
      let delConfirmBtn = document.getElementById('js-ctgryDelete-confirm');
      let delCancelBtn = document.getElementById('js-ctgryDelete-cancel');
      let saveBtn = document.getElementById('js-helpCatName-save');
      let delConfirmDialog = document.getElementById('deleteCtgryDalg');

      //現在のカテゴリーのIDと名前を表示
      if (nameInput && idInput) {
        nameInput.value = catName;
        idInput.value = catId;
      }

      //もしカテゴリーが一つもなければ、カテゴリー削除ボタンを表示
      if (helpsLength === 0 && delBtn && delConfirmDialog) {
        delBtn.style.display = "flex";

        delBtn.onclick = () => {
          delConfirmDialog.classList.toggle('isDsply');
        };
      }
      //カテゴリーがあれば、カテゴリー削除ボタンを非表示
      if (helpsLength !== 0 && delBtn) {
        delBtn.style.display = "none";
      }
      //delConfirmBtnを押された時のイベント
      if (delConfirmBtn) {
        delConfirmBtn.onclick = () => {
          _deleteCat(catId);
          modalToggle(categoryModal, modalBack);
          delConfirmDialog.classList.toggle('isDsply');
        };
      }
      //deleteCancelBtnを押された時のイベント
      if (delCancelBtn) {
        delCancelBtn.onclick = () => {
          modalToggle(categoryModal, modalBack);
          delConfirmDialog.classList.toggle('isDsply');
        };
      }
      //saveBtnを押された時のイベント
      if (saveBtn) {
        saveBtn.onclick = () => {
          _changeCatName(catId, nameInput.value);
          modalToggle(categoryModal, modalBack);
        };
      }

      //モーダル表示
      modalToggle(categoryModal, modalBack);
    };

    const openModal_help = (helpTitle, helpContents, catId = null, helpId = null, orderNum = 0) => {
      let modalBack = document.getElementById('modModalBack');
      let modal = document.getElementById('helpModal');

      let delBtn = document.getElementById('helpDelete');
      let delConfirmBtn = document.getElementById('js-helpDelete-confirm');
      let delCancelBtn = document.getElementById('js-helpDelete-cancel');

      let editBtn = document.getElementById('js-helpEditBTn');
      let disabledWrap = document.getElementById('js-helpDisabledWrap');

      let helpModalMessage = document.getElementById('js-helpModalMessage');
      let titleInput = document.getElementById('js-helpTitle');
      let contentsInput = document.getElementById('js-helpContents');
      let addLinkBtn = document.getElementById('js-addLink');
      let removeLinkBtn = document.getElementById('js-removeLink');

      let saveHint = document.getElementById('js-saveHint');
      let saveBtn_1 = document.getElementById('js-saveBtn-1');
      let saveBtn_2 = document.getElementById('js-saveBtn-2');

      let delConfirmDialog = document.getElementById('deleteHelpDalg');

      //現在のヘルプの内容表示
      if (titleInput && contentsInput) {
        titleInput.value = helpTitle;
        contentsInput.value = helpContents;
      }

      //delBtnを押された時のイベント
      if (delBtn && delConfirmDialog) {
        delBtn.onclick = () => {
          delConfirmDialog.classList.toggle('isDsply');
        };
      }
      //delConfirmBtn, delCancelBtnを押された時のイベント
      [delConfirmBtn, delCancelBtn].forEach(btn => {
        if (btn) {
          btn.onclick = () => {
            //confirmなら削除
            if (btn === delConfirmBtn) {
              _deleteHelp(helpId);
              modalToggle(modal, modalBack);
            }
            delConfirmDialog.classList.toggle('isDsply');
            disabledWrap.classList.toggle('isUnEditable');
          };
        }
      });
      //editボタンを押された時のイベント
      if (editBtn && disabledWrap) {
        editBtn.onclick = () => {
          disabledWrap.classList.remove('isUnEditable');
          saveHint.style.display = "block";
          editBtn.style.display = "none";
          saveBtn_1.style.display = "flex";
          saveBtn_2.style.display = "flex";
        }
      }
      //saveBtnを押された時のイベント
      //公開
      if (saveBtn_1) {
        saveBtn_1.onclick = () => onSaveButtonClick(false);
      }
      //下書き
      if (saveBtn_2) {
        saveBtn_2.onclick = () => onSaveButtonClick(true);
      }

      function onSaveButtonClick(isDraft) {
        const saveFunction = helpId ? _changeHelp : _addHelp;
        saveFunction(helpId, titleInput.value, contentsInput.value, catId, isDraft ? 2 : 1)
          .then(() => {
            modalToggle(modal, modalBack);
            if (!disabledWrap.classList.contains('isUnEditable')) {
              disabledWrap.classList.add('isUnEditable');
            }
            saveHint.style.display = "none";
            saveBtn_1.style.display = "none";
            saveBtn_2.style.display = "none";
            editBtn.style.display = "flex";
            _sync();
          })
          .catch((e) => {
            helpModalMessage.innerText = e;
          });
      }

      //リンクボタンを押された時
      if (addLinkBtn) {
        addLinkBtn.onclick = () => {
          const selectedText = contentsInput.value.substring(contentsInput.selectionStart, contentsInput.selectionEnd);
          if (selectedText) {
            const link = '[link:' + selectedText + ']' + selectedText + '[/link]';
            const start = contentsInput.value.substring(0, contentsInput.selectionStart);
            const end = contentsInput.value.substring(contentsInput.selectionEnd, contentsInput.value.length);
            contentsInput.value = start + link + end;
          }
        }
      }
      //リンク解除ボタンを押された時
      if (removeLinkBtn) {
        removeLinkBtn.onclick = () => {
          const selectedText = contentsInput.value.substring(contentsInput.selectionStart, contentsInput.selectionEnd);
          if (selectedText) {
            const linkRegex = /\[link:(.*?)\](.*?)\[\/link\]/g;
            const matches = selectedText.match(linkRegex);
            let plainText = selectedText;

            if (matches) {
              const linkLength = matches.map(match => {
                const [, $1,] = linkRegex.exec(match);
                return $1.length;
              });

              matches.forEach(function (match, index) {
                plainText = plainText.replace(match, match.substring(6 + linkLength[index] + 1, match.length - 7));
              });
            }
            const link = plainText;
            const start = contentsInput.value.substring(0, contentsInput.selectionStart);
            const end = contentsInput.value.substring(contentsInput.selectionEnd, contentsInput.value.length);
            contentsInput.value = start + link + end;
          }
        }
      }

      //モーダル表示
      modalToggle(modal, modalBack);
    };

    const modalToggle = (modal, back) => {
      modal.classList.toggle('isDsply');
      back.classList.toggle('isDsply');
    }

    //ステータスを変更
    const changeStatus = (id, e) => {
      e.stopPropagation();
      const statusTarget = document.getElementById('status_' + id);
      if (!statusTarget) {
        console.log('no statusTarget');
        return;
      }

      //選択したステータスを取得
      let targetValue = e.currentTarget.querySelector('input');
      if (!targetValue) {
        console.log('no targetValue');
        return;
      }
      targetValue = targetValue.value;

      //選択しているステータスを更新
      statusTarget.innerHTML = "";
      let statusTargetTag = document.createElement('p');
      statusTargetTag.classList.add('pSelectMarker');
      statusTargetTag.classList.add(statusList.value[targetValue].class);
      statusTargetTag.innerText = statusList.value[targetValue].name;
      statusTarget.appendChild(statusTargetTag);

      //  サーバーに伝達
      _changeStatus(id, targetValue);

      //  選択肢を閉じる
      const parent = e.currentTarget.parentElement.parentElement;
      if (parent && parent.classList.contains('isOpen')) {
        parent.classList.remove('isOpen');
      }
    };

    const _getHelpStatus = () => {
      _serverConnect((data) => {
          statusList.value = data;
          _sync();
        },
        'get',
        getHelpStatus_ep
      );
    }

    onMounted(() => {
      if (document.getElementsByClassName('js-successToast') && document.getElementsByClassName('js-successToast').length > 0) {
        successBox.value = document.getElementsByClassName('js-successToast')[0];
      }

      if (document.getElementsByClassName('js-modalBack') && document.getElementsByClassName('js-modalBack').length > 0 && document.getElementById('ctgryModal') && document.getElementById('helpModal')) {
        modalBack.value = document.getElementsByClassName('js-modalBack')[0];
        const modal_cat = document.getElementById('ctgryModal');
        const modal_help = document.getElementById('helpModal');

        modalBack.value.addEventListener('click', (e) => {

          if (modalBack.value.classList.contains('isDsply')) {
            modalBack.value.classList.remove('isDsply');
          }
          if (modal_cat.classList.contains('isDsply')) {
            modal_cat.classList.remove('isDsply');
          }
          if (modal_help.classList.contains('isDsply')) {
            modal_help.classList.remove('isDsply');
          }
        });

        modal_cat.addEventListener('click', (e) => {
          e.stopPropagation();
        });
        modal_help.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }

      //init
      _getHelpStatus();
      addEvents();
    });

    return {
      tokenValue,
      getHelps_ep,
      addCat_ep,
      changeCatName_ep,
      delCat_ep,
      delHelp_ep,
      addHelp_ep,
      changeHelp_ep,
      changeHelpOrder_ep,
      changeHelpStatus_ep,
      getHelpStatus_ep,
      helpList,
      dragging,
      messages,
      statusList,
      openModal_cat,
      openModal_help,
      changeOrder,
      openStatus,
      changeStatus,
    };
  },
}

</script>

<style scoped>
.modBasicTable tbody tr {
  background-color: #FFFFFF;
  -webkit-transition: 0.2s ease-in-out;
  -o-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
}
</style>
